import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { TextArea } from '../../../../../components'

/**
 * Notes
 */
class Notes extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { values, onChange } = this.props

    return (
      <Grid item xs={9} container spacing={3}>
        <Grid item xs={12}>
          <div className='section_title'>Notes</div>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs={8}>
            <TextArea
              id='notes'
              value={values.notes}
              onChange={onChange}
              maxlength={700}
              rows={15} />
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

Notes.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Notes
